<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
      <div v-else>
        <div
          slot="no-body"
          class="tabs-container inventory_tabSec"
          id="view-customer-tab"
        >
          <vs-tabs
            alignment="fixed"
            v-model="activeTab"
            class="tab-action-btn-fill-conatiner"
          >
            <vs-tab :label="$t('sidebar.label.order_management')">
              <vx-card>
                <vs-table
                  :max-items="descriptionItems[1]"
                  pagination
                  :description="false"
                  :data="accounting"
                  search
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="header">
                    <div class="list-heading">
                      {{ $t("sidebar.label.order_management") }}
                    </div>
                    <div class="mb-1 order-1">
                      <div class="flex items-center mb-3">
                <div class="p-1 mt-2 flex items-center text-lg font-medium w-full date-field">
                  <datepicker
                    name="start-date"
                    :placeholder="$t('customers.label.start_date')"
                    v-model="orderSearch.startDate"
                    :disabled-dates="disabledDates"
                  ></datepicker>
                </div>
                <div class="p-1 mt-2 flex items-center text-lg font-medium w-full date-field">
                  <datepicker
                    name="end-date"
                    class="end-date-calender"
                    :placeholder="$t('customers.label.end_date')"
                    v-model="orderSearch.endDate"
                    :disabled-dates="disabledDates"
                  ></datepicker>
                </div>
                <div class="p-1 flex items-center text-lg font-medium w-full">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    class="mr-sm-3 mt-2"
                    icon="icon-search"
                    @click="searchOrderList"
                  ></vs-button>
                </div>
              </div>
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("admin.label.Id") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Client Id") }}</vs-th>
                    <vs-th>{{ $t("customers.label.customer_name") }}</vs-th>
                    <vs-th>{{ $t("Service No") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Device") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Request Type") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Status") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Created Date") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Response Message") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Response Status") }}</vs-th>
                    <vs-th class="tHeadCenter">{{ $t("admin.label.Actions") }}</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="index" :data="accounting" v-for="(accounting, index) in data">
                      <vs-td :data="accounting.id">{{ accounting.id }}</vs-td>
                      <vs-td :data="accounting.client_id">{{ accounting.client_id }}</vs-td>
                      <vs-td :data="accounting.displayName">{{ accounting.displayName }}</vs-td>
                      <vs-td :data="accounting.service_no">{{ accounting.service_no }}</vs-td>
                      <vs-td :data="accounting.serial_no">{{ accounting.serial_no }}</vs-td>
                      <vs-td :data="accounting.request_type">{{ accounting.request_type }}</vs-td>
                      <vs-td :data="accounting.status">{{ accounting.status }}</vs-td>
                      <vs-td :data="getDate(accounting.created_date)">{{
                        getDate(accounting.created_date)
                      }}</vs-td>
                      <vs-td :data="accounting.response_message" class="text-center">{{
                        accounting.response_message || "-"
                      }}</vs-td>
                      <vs-td :data="accounting.response_status">{{
                        accounting.response_status
                      }}</vs-td>
                      <vs-td class="whitespace-no-wrap">
                        <div class="container_img">
                          <feather-icon
                            icon="PlayIcon"
                            title="Re Process"
                            svgClasses="w-5 h-5 stroke-current cursor"
                            @click.stop="
                              editJobsPopup = true;
                              orderId = accounting.id;
                            "
                            class="icon_row"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vx-card>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('admin.label.ReProcess Provisioning Order')"
                  :active.sync="editJobsPopup"
                  class="popup-close mid-popup"
                >
                  <form>
                    <div class="vx-row md:w-full lg:w-full sm:w-full mb-6 center">
                      <div class="vx-col sm:w-full w-full">
                        <div class="vx-col sm:w-full w-full">Are you sure?</div>
                      </div>
                    </div>
                    <div class="vx-row text-center">
                      <div class="vx-col sm:w-full w-full" style="padding-right: 8%">
                        <vs-button class="mr-2" type="border" @click="editJobsPopup = false">
                          {{ $t("admin.label.Cancel") }}
                        </vs-button>

                        <vs-button @click="reProcessOrder(orderId)" color="warning">
                          {{ $t("admin.label.Ok") }}
                        </vs-button>
                      </div>
                    </div>
                  </form>
                </vs-popup>
              </div>
            </vs-tab>
            <vs-tab :label="$t('admin.label.ConductorReport')">
                <div>
                  <div class="flex items-center mb-3">
                      <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
                        {{ $t("admin.label.ConductorReport") }}
                      </div>
                      <ul class="horizontal-sm-btn flex mb-2 order-1">
                        <li>
                          <div
                            class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                          >
                            <datepicker
                              name="start-date"
                              :placeholder="$t('customers.label.start_date')"
                              v-model="searchOne.startDate"
                            ></datepicker>
                          </div>
                        </li>
                        <li>
                          <div
                            class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                          >
                            <datepicker
                              name="end-date"
                              class="end-date-calender"
                              :placeholder="$t('customers.label.end_date')"
                              v-model="searchOne.endDate"
                            ></datepicker>
                          </div>
                        </li>
                        <li>
                          <div
                            class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                          >
                            <vs-button
                              color="primary"
                              type="border"
                              icon-pack="feather"
                              class="mr-sm-3 mt-1"
                              icon="icon-search"
                              @click="searchStatus()"
                            ></vs-button>
                          </div>
                        </li>
                      </ul>
                    </div>
                  <vx-card class="chart-card" title="Daily Conductor Workflow Status">
                    <div class="chart-wrapper">
                      <div v-if="isLoading" class="overlay-loader">
                        <div class="spinner"></div>
                      </div>

                      <apexchart
                        type="line"
                        height="400"
                        :options="chartOptions"
                        :series="series"
                      />
                    </div>
                  </vx-card>
                  <vx-card title="Workflow Numeric Metrics by Status" class="chart-card mt-3">
                    <div class="chart-wrapper">
                      <div v-if="isLoading" class="overlay-loader">
                        <div class="spinner"></div>
                      </div>

                      <apexchart
                        type="line"
                        height="400"
                        :options="secondChartOptions"
                        :series="secondChartSeries"
                      />
                    </div>
                  </vx-card>
                </div>
            </vs-tab>
          </vs-tabs>
        </div>
        <validation-popup
          :errorMessage="errorMessage"
          :warningPopup="warningPopup"
          :warningText="warningText"
          @closeWarning="warningPopup = false"
        ></validation-popup>
      </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import VueApexCharts from "vue-apexcharts";
import { AddTicket } from "@/assets/images/icons/AddTicket.png";
import moment from "moment";
import { VTree, VSelectTree } from "vue-tree-halower";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
const chartOneData = {
        chart: {
          type: "line",
          height: 400,
          zoom: { enabled: false },
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: [],
          labels: {
            rotate: -45,
            format: "yyyy-MM-dd",
          },
        },
        markers: {
          size: 6,
          strokeWidth: 3,     
          strokeColors: "#fff", 
          fillOpacity: 1,
          shape: "circle",   
          hover: {
            size: 8,          
          },
        },
        stroke: {
          width: 2,
        },
        legend: {
          position: "top",
        },
        colors: [],
        tooltip: {
          x: { format: "yyyy-MM-dd" },
        },
      }
const chartTwoData = {
        chart: {
          type: 'line',
          height: 400,
          zoom: { enabled: false },
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          type: 'category',
          categories: [],
          labels: {
            rotate: -45,
            format: "dd-MM-yyyy",
          },
        },
        stroke: {
          width: 2,
        },
        markers: {
          size: 6,
          strokeWidth: 3,     
          strokeColors: "#fff", 
          fillOpacity: 1,
          shape: "circle",   
          hover: {
            size: 8,          
          },
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        legend: {
          position: 'top',
        },
      }
export default {
  data() {
    return {
      activeTab: 0,
      loading: false,
      isLoading: false,
      orderId: 0,
      editJobsPopup: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      searchOption: 0,
      treeview: false,
      ticketPopup: false,
      descriptionItems: [5, 10, 15],
      updateCraditPopup: false,

      searchOne: {
        startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      orderSearch: {
        startDate:moment().subtract(7,'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      disabledDates: {
      from: new Date(new Date().setDate(new Date().getDate()))
    },

      series: [],
      chartOptions: chartOneData,

      secondChartOptions: chartTwoData,
      secondChartSeries: [],
    };
  },
  components: {
    VTree,
    VSelectTree,
    AddTicket,
    Datepicker,
    flatPickr,
    "v-select": vSelect,
    AtomSpinner,
    apexchart: VueApexCharts,
  },
  computed: {
    ...mapState({
      accounting: (state) => state.admin.listing,
      conductorWorkflowData: (state) => state.admin.conductorWorkflowData,
      statusWiseConductorData: (state) => state.admin.statusWiseConductorData,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    async reProcessOrder(id) {
      try {
        await this.$store.dispatch("admin/setUpdateProvisioningOrderAction", id, {});
        this.getAccountingList();
        this.editJobsPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    // async getAccountingList() {
    //   this.loading = true;
    //   try {
    //     await this.$store.dispatch("admin/setAccountingAction", {});
    //     this.loading = false;
    //   } catch (error) {
    //     throw Error(
    //       error.message.errors[0].defaultUserMessage ||
    //         `Api failed with status code: ${error.message.httpStatusCode}`
    //     );
    //   }
    // },
    async searchOrderList() {
      this.loading = true;
  try {
    const payload = {
      startDate: this.orderSearch.startDate 
        ? moment(this.orderSearch.startDate).format("YYYY-MM-DD")
        : null,
      endDate: this.orderSearch.endDate
        ? moment(this.orderSearch.endDate).format("YYYY-MM-DD")
        : null,
    };

    if (payload.startDate && payload.endDate && payload.startDate > payload.endDate) {
      this.$toasted.error("Start date cannot be greater than end date", { duration: 2000 });
      this.loading = false;
      return;
    }

    await this.$store.dispatch("admin/getOrderDateFilterAction", payload);
  } catch (error) {
    this.$toasted.error(error.message || "Failed to fetch orders", { duration: 2000 });
  } finally {
    this.loading = false;
  }
    },
    async fetchData() {
      this.isLoading = true;
      try {
        const data={
          startDate: moment(this.searchOne.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.searchOne.endDate).format("YYYY-MM-DD"),
        }
        await this.$store.dispatch("admin/getConductorWorkflowStatusAction", data);
        const rawData = this.conductorWorkflowData.data.map(d => ({
          workflow_name: d.row[0],
          day_slot: d.row[1],
          total: d.row[2],
        }));

        this.prepareChart(rawData);
        this.isLoading = false;
      } catch (error) {
        this.$toasted.error(error, {
          duration: 2000,
        });
        this.isLoading = false;
      }
    },
    async getStatusWiseChartMethod() {
      this.isLoading = true;
      try {
        const data={
          startDate: moment(this.searchOne.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.searchOne.endDate).format("YYYY-MM-DD"),
        }
        await this.$store.dispatch("admin/getStatusWiseChartAction", data);
        this.processSecondChart();
        this.isLoading = false;
      } catch (error) {
        this.$toasted.error(error, {
          duration: 2000,
        });
        this.isLoading = false;
      }
    },

    prepareChart(data) {
      const workflows = [...new Set(data.map(d => d.workflow_name))];

      const allDates = [...new Set(data.map(d => d.day_slot))].sort((a, b) =>
        a.localeCompare(b)
      );

      const grouped = workflows.map(workflow => {
        const workflowData = allDates.map(date => {
          const entry = data.find(
            d => d.workflow_name === workflow && d.day_slot === date
          );
          return entry ? entry.total : 0;
        });

        return {
          name: workflow,
          data: workflowData,
        };
      });

      // Update x-axis categories first
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          ...this.chartOptions.xaxis,
          categories: allDates,
        },
      };

      // Then set series
      this.series = grouped;
    },
    processSecondChart() {
      const { columnHeaders, data } = this.statusWiseConductorData;

      const integerColumns = columnHeaders
        .map((col, index) => ({ ...col, index }))
        .filter((col) => col.columnDisplayType === 'INTEGER');

      const daySlotIndex = columnHeaders.findIndex((col) => col.columnName === 'day_slot');

      const uniqueDates = [...new Set(data.map((rowObj) => rowObj.row[daySlotIndex]))].sort();

      this.secondChartOptions = {
        ...this.secondChartOptions,
        xaxis: {
          ...this.secondChartOptions.xaxis,
          categories: uniqueDates,
        },
      };

      this.secondChartSeries = integerColumns.map((col) => { 
        const seriesData = uniqueDates.map((date) => {
          const row = data.find((rowObj) => rowObj.row[daySlotIndex] === date);
          return row ? row.row[col.index] : 0;
        });

        return {
          name: col.columnName,
          data: seriesData,
        };
      });
    },
    async searchStatus(){
      this.fetchData();
      this.getStatusWiseChartMethod();
    }
  },
  watch: {
    async activeTab(newVal) {
      if (newVal === 1) {
        this.chartOptions= JSON.parse(JSON.stringify(chartOneData));
        this.secondChartOptions= JSON.parse(JSON.stringify(chartTwoData));
        this.series= [],
        this.secondChartSeries= [],
        this.fetchData();
        this.getStatusWiseChartMethod();
      }
    },
  },
  async mounted() {
    await this.searchOrderList();
    // await this.getAccountingList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}
.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
  .chart-container {
  width: 100%;
  height: 400px;
}
</style>
<style lang="scss">
.chart-card .vx-card__header {
    justify-content: center !important;
}
.end-date-calender .vdp-datepicker__calendar {
  right: 0;
}
.chart-wrapper {
  position: relative;
  height: 400px;
}

.overlay-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); /* translucent white background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ccc;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
